const reviews = [
  ["Aanya", "My skin barrier feels calmer within two weeks. The texture is so premium."],
  ["Mira", "The serum layers beautifully and gives a natural, healthy glow."],
  ["Sara", "Minimal routine, visible results, and the packaging feels luxurious."],
];

const Testimonials = () => {
  return (
    <section className="testimonials-section" id="clients">
      <div className="section-container">
        <div className="section-heading center">
          <p>Real results</p>
          <h2>What Customers Say</h2>
        </div>

        <div className="testimonial-grid">
          {reviews.map(([name, text]) => (
            <article key={name} className="glass-card">
              <div className="avatar">{name.charAt(0)}</div>
              <p>"{text}"</p>
              <strong>{name}</strong>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
